import axios from 'axios';
import { get } from "lodash";
import { getCookie } from "../helpers/storage";

var adminApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

adminApi.interceptors.request.use((config) => {
    let conf = {
        ...config,
        headers: {
            ...config.headers,
            'Authorization': 'Bearer ' + (getCookie('token') || false)
        }
    }
    return conf;
})

adminApi.interceptors.response.use(response => {
    let data = get(response, "data");
    return {
        ...response,
        data
    }
}, (error) => {
    // const { status } = get(error, "response", {});
    // if (status === 401) {
    //     deleteCookie();
    //     window.location.href = `${process.env.REACT_APP_URL_PREFIX}/`;
    // }
    return Promise.reject(error)
})

export default adminApi;